import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { IdResult } from '@models/index';
import {
  CanSendAllAnswers,
  ComplementaryForm,
  JobApplicationComplementaryFormSaveRequest,
  JobApplicationComplementaryFormTemplate,
} from '@services/questions/job-application-complementary-form.model';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class JobApplicationComplementaryFormService {
  constructor(private httpClient: HttpClient) {}

  public exist(jobOpportunityId: string, tenantId: string): Observable<boolean> {
    return this.httpClient
      .get<boolean>(
        `${environment.applicantApiEndpoint}/jobapplications-complementary-form/exist/${jobOpportunityId}/${tenantId}`,
      )
      .pipe(take(1));
  }

  public get(jobOpportunityId: string, tenantId: string): Observable<ComplementaryForm> {
    return this.httpClient
      .get<ComplementaryForm>(
        `${environment.applicantApiEndpoint}/jobapplications-complementary-form/questions/${jobOpportunityId}/${tenantId}`,
      )
      .pipe(take(1));
  }

  public getComplementaryFormTemplates(
    jobApplicationId: string,
    stepId: string,
  ): Observable<JobApplicationComplementaryFormTemplate[]> {
    return this.httpClient
      .get<
        JobApplicationComplementaryFormTemplate[]
      >(`${environment.applicantApiEndpoint}/jobapplications-complementary-form/questions/job-application/${jobApplicationId}/${stepId}`)
      .pipe(take(1));
  }

  public saveComplementaryFormTemplate(
    templateWithAnswers: JobApplicationComplementaryFormSaveRequest,
  ): Observable<CanSendAllAnswers> {
    return this.httpClient.patch<CanSendAllAnswers>(
      `${environment.applicantApiEndpoint}/jobapplications-complementary-form/questions/set-answers`,
      templateWithAnswers,
    );
  }

  public sendComplementaryFormTemplates(
    jobApplicationId: string,
    stepId: string,
  ): Observable<IdResult> {
    return this.httpClient.put<IdResult>(
      `${environment.applicantApiEndpoint}/jobapplications-complementary-form/questions/job-application/${jobApplicationId}/${stepId}/complete`,
      {},
    );
  }
}
